<template>
    <div class="row " style="min-width: 1200px; min-height: 100%; overflow: auto !important;">

        <LightGallery :disable-scroll="true" :images="fullScreenImageArr" :index="imageIndex"
                      @close="fullScreenImageDialog=false" v-if="fullScreenImageDialog"></LightGallery>
        <q-dialog position="right" v-model="schemePointDialog">
            <scheme-point-detail :isTeam="schemeDetail.isHerirachyScheme" :scheme-id="id"
                                 :schemeDetail="schemeDetail" :schemeEnrollmentObj="schemeEnrollmentObj"
                                 @closeDialog="schemePointDialog=false"></scheme-point-detail>
        </q-dialog>

        <q-dialog persistent position="right" v-model="redeemPointDialog">
            <RedeemPoint :scheme-enrollment-obj="schemeEnrollmentObj" :schemeDetail="schemeDetail"
                         @closeRedeemPointDialog="redeemPointDialog=false"
                         @refetchSchemePoints="refetchSchemePoints"></RedeemPoint>
        </q-dialog>
        <q-dialog persistent position="right" v-model="redeemHistoryDialog">
            <RedeemHistory :partnerId="user.orgId" :schemeId="id"
                           @closeDialog="redeemHistoryDialog=false"></RedeemHistory>
        </q-dialog>
        <q-dialog persistent position="right" v-model="showReturnOrderHistory">
            <ReturnOrderHistory :partner-id="user.orgId" :scheme-id="id"
                                @closeDialog="showReturnOrderHistory=false"></ReturnOrderHistory>
        </q-dialog>
        <q-dialog persistent position="right" v-model="showTransferHistory">
            <TransferHistory :partnerId="user.orgId" :schemeId="id" :startDate="schemeStartDate"
                             :endDate="schemeEndDate" @closeDialog="showTransferHistory=false"/>
        </q-dialog>
        <div class="card">
            <div class="row">
                <div class="col-8 q-pa-md">
                    <div class="d-flex justify-content-between mb-3" style="align-items: center">
                        <div class="scheme-title">
                            <h4 class="mt-0 mb-1" style="font-size: 22px; font-weight: 300">
                                {{schemeDetail.name}}
                            </h4>
                        </div>
                        <div class="d-flex" style="align-items: center;">
                            <div class=" scheme-time p-2 d-flex">
                                <div class="pr-2">
                                    <label class="bankLabel">From</label>
                                    <span class="d-block" style="letter-spacing: 1.5px;">{{schemeDetail.startTime|dateFilter}}</span>
                                </div>
                                <div class="pl-2">
                                    <label class="bankLabel">To</label>
                                    <span class="d-block" style="letter-spacing: 1.5px;">{{schemeDetail.endTime|dateFilter}}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Carousel-->
                    <div class="row">
                        <div class="col-12" v-if="schemeDetail.schemeDocumentType==='Images'">
                            <template>
                                <q-carousel animated arrows infinite style="overflow: hidden; border-radius: 5px;"
                                            thumbnails
                                            v-model="carouselModal">
                                    <q-carousel-slide :img-src="img.url" :key="index" :name="index"
                                                      @click="viewRoomImage(schemeDetail.schemeDocuments, index)"
                                                      v-for="(img,index) in schemeDetail.schemeDocuments "/>
                                </q-carousel>
                            </template>
                        </div>

                        <div class="col-12" v-else-if="schemeDetail.schemeDocumentType==='Document'">
                            <div class=" position-relative">
                                <img alt="" class="w-100" src="../../../src/assets/downloadPDF.png">
                                <a :href="schemeDetail.schemeDocuments[0].url"
                                   class="download-pdf position-absolute" target="_blank"
                                   v-if="schemeDetail.schemeDocuments.length">DOWNLOAD</a>
                            </div>
                        </div>

                        <div class="col-12 mt-3" v-if="schemeDetail.description">
                            <div class=" p-3 ">
                                <div class="text-h6 mb-3">Description</div>
                                <p style="font-size: 16px; text-align: justify"
                                   v-html="schemeDetail.description"></p>
                            </div>
                            <hr style="border: 1px solid lightgray !important; opacity: 0.3">
                        </div>
                        <div class="col-12 mt-3" v-if="schemeDetail.tnc">
                            <div class=" p-3 ">
                                <div class="text-h6 mb-3">Terms and Conditions</div>
                                <p style="font-size: 16px; text-align: justify"
                                   v-html="schemeDetail.tnc"></p>
                            </div>
                            <hr style="border: 1px solid lightgray !important; opacity: 0.3">
                        </div>

                        <div class="col-12 mt-3" v-if="schemeDetail.pointMethod == 'GOAL_BASED'">
                            <div class="p-3">
                                <h6 class="text-h6 mb-3">Goals</h6>

                                <div class="GoalBox py-2" v-for="goal in schemeDetail.goalPoints">
                                    <p class="mb-2">{{goal.name}}</p>
                                    <div class="row ">
                                        <div class="col-1">
                                            <div class="thumbnail">
                                                <img :src="goal.imageArr.length?goal.imageArr[0].url:defaultGoalImage"
                                                     class="w-100">
                                            </div>
                                        </div>
                                        <div class="col-4 px-3">
                                            <div class="GoalDetails ">
                                                <div class="d-flex justify-content-between">
                                                    <div>
                                                        <span class="bankLabel">Goal Value</span>
                                                        <p>{{goal.value}}</p>
                                                    </div>

                                                    <div v-if="(goal.value-closingPoints)>0">
                                                        <span class="bankLabel">Remaining Points</span>
                                                        <p>{{goal.value-closingPoints}}</p>
                                                    </div>
                                                    <div class="ml-5"
                                                         v-if="(goal.value-closingPoints)<=0&&(schemeDetail.endTime<moment().format('YYYY-MM-DD') || schemeDetail.canRedeemPointInCurrentGoal)">
                                                        <q-btn :disabled="disableRedeemBtn"
                                                               @click="onRedeemGoalPoints(goal.id, goal.name, goal.value)"
                                                               class="pd-btn">
                                                            Redeem
                                                        </q-btn>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-6 d-flex" style="justify-content: flex-end">
                                            <q-circular-progress :thickness="0.12"
                                                                 :value="(goal.value-closingPoints)>=0?(closingPoints*100)/goal.value:100"
                                                                 class="q-ma-md mt-0" color="blue-10" font-size="12px"
                                                                 show-value size="50px" track-color="grey-3">
                                                {{(goal.value-closingPoints)>=0?Math.round(((closingPoints*100)/goal.value)
                                                * 100) / 100 :100 }} %
                                            </q-circular-progress>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mt-3">
                            <div class=" p-3" style="height: auto;">
                                <div class="d-flex justify-content-between mb-3">
                                    <div class="text-h6 ">Products</div>
                                    <div class="transferButton" style=" text-align: center;">
                                        <p style="line-height: 40px; font-size: 16px">
                                            {{schemeDetail.SchemaPointView?schemeDetail.SchemaPointView.length:0}}</p>
                                    </div>
                                </div>
                                <template v-if="schemeDetail.SchemaPointView&&schemeDetail.SchemaPointView.length">
                                    <div class="row" style="border-bottom: 1px solid #e0e0e0; color: #6e7b7b">
                                        <div class="col-8 py-3">Product</div>
                                        <div class="col-2 py-3" style="text-align: center">Points</div>
                                        <div class="col-2 py-3" style="text-align: center">Quantity</div>
                                    </div>
                                    <div v-for="sku in schemeDetail.SchemaPointView">
                                        <div class="row" style="border-bottom: 1px solid #e0e0e0">
                                            <div class="col-8 py-3">{{sku.productname}}</div>
                                            <div class="col-2 py-3" style="text-align: center">{{sku.points}}</div>
                                            <div class="col-2 py-3" style="text-align: center">{{sku.quantity}}</div>
                                        </div>
                                    </div>
                                </template>
                                <template class="p-2" v-else>No Products Available</template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-4 q-pa-md"
                     style="border-radius: 20px 0px 0px 20px">
                    <div class="col-12">
                        <div @click="closeViewScheme" class="drawerButtons float-right" style="margin-top: 0px;">
                            <q-btn flat icon="close" round size="small"></q-btn>
                        </div>
                    </div>
                    <HeaderPoints :scheme-detail="schemeDetail"
                                  :scheme-enrollment-obj="schemeEnrollmentObj"></HeaderPoints>
                    <div class="col-4" style="">
                        <div class=" mt-3" style="height: auto">
                            <div class="row">
                                <div class="col-12 my-2">
                                    <SummaryPoints :scheme-detail="schemeDetail" :scheme-enrollment-obj="schemeEnrollmentObj"
                                                   @showAdjustmentHistory="showAdjustmentHistory=true"
                                                   @showReturnOrderHistory="showReturnOrderHistory=true"
                                                   @showTransferHistory="showTransferHistory=true"/>
                                </div>
                                <div class="col-12 my-2">
                                    <MyPoints :scheme-detail="schemeDetail"
                                              :scheme-enrollment-obj="schemeEnrollmentObj"></MyPoints>
                                </div>
                                <div class="col-12 my-2"
                                     v-if="schemeDetail.isHerirachyScheme">
                                    <MyTeamPoints :scheme-detail="schemeDetail"
                                                  :scheme-enrollment-obj="schemeEnrollmentObj"></MyTeamPoints>
                                </div>

                                <div class="col-6 my-2 text-left">
                                    <q-btn @click="schemePointDialog=true" class="pd-btn mx-auto">View Detail</q-btn>
                                </div>
                                <!-- -------------------- COMMENTED FOR LIVE ENV -----------------------  -->
                                <div class="col-6 my-2 text-left"
                                     v-if="schemeDetail.pointMethod == 'CONTINUOUS'&&schemeDetail.isSelfRedemption">
                                    <q-tooltip>
                                        Minimum Redeem Points set is {{schemeDetail.points}}
                                    </q-tooltip>
                                    <q-btn :disabled="closingPoints<schemeDetail.points||disableRedeemBtn"
                                           @click="redeemPointDialog=true"
                                           class="pd-btn mx-auto" label="Redeem">
                                    </q-btn>
                                </div>
                                <div class="col-6 my-2 text-left">
                                    <q-btn @click="redeemHistoryDialog=true" class="pd-btn mx-auto">REDEEM HISTORY
                                    </q-btn>
                                </div>
                                <!-- -------------------x------------------x-----------------x------------- -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {GET_SCHEME_DETAIL_WITH_POINTS} from '../../graphql/queries/schemes'
    import {SUBSCRIBE_SCHEME_DETAIL_WITH_POINTS} from '../../graphql/subscription/schemes'
    import {INSERT_REDEEM_POINTS} from '../../graphql/mutations/redeemPoints'
    import Constants from '../../Constants/Constant'
    import moment from 'moment'
    import {LightGallery} from 'vue-light-gallery'
    import SchemePointDetail from './SchemePointDetail'
    import RedeemPoint from './RedeemPoint'
    import RedeemHistory from './RedeemHistory'
    import HeaderPoints from '../Common/HeaderPoints'
    import SummaryPoints from '../Common/SummaryPoints'
    import MyPoints from '../Common/MyPoints'
    import MyTeamPoints from '../Common/MyTeamPoints'
    import ReturnOrderHistory from '../ReturnOrder/ReturnOrderHistory'
    import TransferHistory from "./TransferHistory";

    export default {
        name: 'SchemeDetail',
        components: {
            TransferHistory,
            ReturnOrderHistory,
            MyTeamPoints,
            MyPoints,
            SummaryPoints,
            HeaderPoints,
            RedeemHistory,
            SchemePointDetail,
            LightGallery,
            RedeemPoint,
        },
        props: ['id'],
        data() {
            return {
                moment: moment,
                schemePoints: null,
                schemeTotalPoints: null,
                constants: Constants,
                schemeDetail: '',
                carouselModal: 0,
                user: JSON.parse(localStorage.getItem('user')),
                orgs: [],
                startDate: moment().startOf('month').format('YYYY-MM-DD'),
                endDate: moment().endOf('month').format('YYYY-MM-DD'),
                startDateZ: moment().startOf('month'),
                endDateZ: moment().endOf('month'),
                closingPoints: 0,
                fullScreenImageDialog: false,
                imageIndex: 0,
                fullScreenImageArr: [],
                schemePointDialog: false,
                redeemPointDialog: false,
                defaultGoalImage: require('../../assets/otp.png'),
                redeemHistoryDialog: false,
                disableRedeemBtn: false,
                schemeEnrollmentObj: {
                    myTeamEarnPoint: 0,
                    myTeamEligiblePoint: 0,
                    earnPoint: 0,
                    eligiblePoint: 0,
                    redemPoint: 0,
                    redemptioInProgress: 0,
                    transferPoints: 0,
                    adjustment: 0,
                    returnOrderPoint: 0,
                },
                showAdjustmentHistory: false,
                showReturnOrderHistory: false,
                showTransferHistory: false,
                schemeStartDate: null,
                schemeEndDate: null,
            }
        },
        apollo: {
            Scheme: {
                query: GET_SCHEME_DETAIL_WITH_POINTS,
                fetchPolicy: 'network-only',
                skip() {
                    return !this.id
                },
                variables() {
                    return {
                        id: this.id,
                        partnerId: JSON.parse(localStorage.getItem('user')).organization.id,
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_SCHEME_DETAIL_WITH_POINTS,
                    skip() {
                        return !this.id
                    },
                    variables() {
                        return {
                            id: this.id,
                            partnerId: JSON.parse(localStorage.getItem('user')).organization.id,
                        }
                    },
                    updateQuery: function (previousQueryResult, {subscriptionData}) {
                        this.schemeDetail = subscriptionData.data.Scheme[0]
                        this.schemeStartDate = this.schemeDetail.startTime;
                        this.schemeEndDate = this.schemeDetail.endTime;
                        this.schemeEnrollmentObj = subscriptionData.data.Scheme[0].SchemeEnrollments.length
                            ? subscriptionData.data.Scheme[0].SchemeEnrollments[0]
                            : this.schemeEnrollmentObj
                        this.closingPoints = this.calculateClosingPoints(this.schemeEnrollmentObj, this.schemeDetail);
                    },
                },
                result({data, loading}) {
                    if (!loading) {
                        this.schemeDetail = data.Scheme[0]
                        this.schemeEnrollmentObj = data.Scheme[0].SchemeEnrollments.length
                            ? data.Scheme[0].SchemeEnrollments[0]
                            : this.schemeEnrollmentObj
                        this.closingPoints = this.calculateClosingPoints(this.schemeEnrollmentObj, this.schemeDetail);
                    }
                },
            },
        },
        methods: {
            viewRoomImage(imagesArr, index) {
                var self = this
                this.fullScreenImageArr = []
                this.imageIndex = index
                imagesArr.forEach(function (img) {
                    self.fullScreenImageArr.push({url: img.url, title: ''})
                })
                this.fullScreenImageDialog = true
            },
            onRedeemGoalPoints(goalId, goalName, goalValue) {
                var self = this
                this.$q.dialog({
                    title: 'Goal Points Redeem',
                    message: 'Are you Sure, you want to Redeem Goal ' + goalName + ' ?',
                    cancel: true,
                    persistent: true,
                }).onOk(() => {
                    self.insertRedeemPoints(goalId, goalName, goalValue)
                })
            },
            async insertRedeemPoints(goalId, goalName, goalValue) {
                this.disableRedeemBtn = true
                let response = await this.$apollo.mutate({
                    mutation: INSERT_REDEEM_POINTS,
                    variables: {
                        id: this.generateUUID(),
                        createdBy: this.user.id,
                        partnerId: this.user.orgId,
                        schemeId: this.schemeDetail.id,
                        goalId: goalId,
                        goalName: goalName,
                        points: Number(goalValue),
                        status: 'Pending',
                        lastUpdatedBy: this.user.id,
                        approvedBy: null,
                        rejectedBy: null,
                        updatedOn: moment().format(),
                        goalName: goalName,
                    },
                })
                if (response.data) {
                    this.$q.notify('Goal Points redeemed successfully')
                    this.$apollo.queries.Scheme.refetch()
                }
            },
            refetchSchemePoints() {
                this.disableRedeemBtn = true
                this.$apollo.queries.Scheme.refetch()
            },
            generateUUID() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
                    return v.toString(16)
                })
            },
            closeViewScheme() {
                this.$emit('onCloseViewScheme')
            },
        },
    }
</script>

<style scoped>
    .card {
        /*text-align: center;*/
        width: 100%;
        /*padding: 30px 40px;*/
        /*margin: auto;*/
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
    }

    .closing-point-bar {
        background-color: green;
        height: 15px
    }

    .eligible-point-bar {
        background-color: orange;
        height: 15px
    }

    .remaining-point-bar {
        background-color: grey;
        height: 15px
    }
</style>
